import { useEffect } from 'react'
import * as Redux from 'redux'
import { connect } from 'react-redux'
import { Grid } from '@mui/material'
import { useHistory } from 'react-router-dom'
import ClientFirearmActions from '@ClientActions/firearm.action'
import BaseButton from '@Components/Form/BaseButton/BaseButton'
import PageHeader from '@Components/Pages/PageHeader/PageHeader'
import { ICommonQuery, IPageHeaderActions } from '../../../models/common.model'
import './firearm.scss'
import { FirearmInsurance } from './insurance'
import { Payment } from './Payment'
import { IRootStates } from '../../../models/store.model'
import { IFirearms } from '../../../models/client/firearm.model'

const Firearmlist = (props: any) => {
    const { data } = props
    const history = useHistory()
    const viewDetail = (id: string) => {
        history.push(`/detail-firearm/${id}`)
    }
    return (
        <div className="firearm-box" key={data?.id}>
            <div className="text-center p-3 firearm-img-box">
                <img
                    src={`require(${data?.imageUrl}).default`}
                    alt=""
                    className="firearm-img"
                    onError={(e: any) => {
                        e.target.onerror = null
                        e.target.src =
                            data?.imageUrl ||
                            require('@Images/icons/camera-icon.svg').default
                    }}
                />
            </div>
            <div className="page-border-top p-3">
                <p className="name m-0">{data?.name}</p>
                <span className="description">
                    {data?.serialCode}{' '}
                    {data?.serialCode &&
                        (data?.capacity || data?.safeType?.name) &&
                        '|'}{' '}
                    {data?.capacity}{' '}
                    {data?.capacity && data?.safeType?.name && '|'}{' '}
                    {data?.safeType?.name}
                    {/* {`${data?.serialCode ? `${data?.serialCode}` : ''}  ${
                        data?.capacity ? `| ${data?.capacity}` : ''
                    } ${
                        data?.safeType?.name ? `| ${data?.safeType?.name}` : ''
                    }`} */}
                    <br />
                </span>
                <div className="mt-1">
                    <BaseButton
                        className="outline-red text-right"
                        onClick={() => viewDetail(data?.id)}
                    >
                        View Detail
                    </BaseButton>
                </div>
            </div>
        </div>
    )
}

interface IFirearmProps {
    getFirearms?: any
    firearms: IFirearms[]
    metadataFirearms?: {
        total: number
    }
    getAccessories?: any
    getParts?: any
    accessories: IFirearms[]
    metadataAccessories?: {
        total: number
    }
    parts: IFirearms[]
    metadataParts: {
        total: number
    }
}

function Firearm(props: IFirearmProps) {
    const {
        getFirearms,
        firearms,
        metadataFirearms,
        getAccessories,
        getParts,
        accessories,
        metadataAccessories,
        parts,
        metadataParts,
    } = props
    const history = useHistory()

    const headerActions: IPageHeaderActions[] = [
        {
            name: 'Add Firearms',
            value: '/firearms/add-Firearms',
        },
    ]

    const onHandleActions = (value: string) => {
        history.push(value)
    }

    useEffect(() => {
        const params = {
            statuses: 'BOUGHT|STOLEN|LOST',
            isDetail: true,
        }
        getFirearms(params)
        getAccessories(params)
        getParts(params)
    }, [])

    return (
        <div className="page-firearm">
            <PageHeader title="Firearm" total={metadataFirearms?.total} />
            <Grid container spacing={2} className="mb-4">
                {firearms?.length > 0 &&
                    firearms.map((item) => {
                        return (
                            <Grid item lg={4} md={6} sm={12} key={item?.id}>
                                <Firearmlist data={item} type="FIREARM" />
                            </Grid>
                        )
                    })}
                {!firearms?.length && <p className="no-data">No data</p>}
            </Grid>
            <PageHeader title="Accessory" total={metadataAccessories?.total} />
            <Grid container spacing={2} className="mb-4">
                {accessories?.length > 0 &&
                    accessories.map((item) => {
                        return (
                            <Grid item lg={4} md={6} sm={12} key={item?.id}>
                                <Firearmlist data={item} type="ACCESSORY" />
                            </Grid>
                        )
                    })}
                {!accessories?.length && <p className="no-data">No data</p>}
            </Grid>
            <PageHeader title="Part" total={metadataParts?.total} />
            <Grid container spacing={2} className="mb-4">
                {parts?.length > 0 &&
                    parts.map((item) => {
                        return (
                            <Grid item lg={4} md={6} sm={12} key={item?.id}>
                                <Firearmlist data={item} type="PART" />
                            </Grid>
                        )
                    })}
                {!parts?.length && <p className="no-data">No data</p>}
            </Grid>
            <PageHeader title="Insurance" />
            <Grid container spacing={2}>
                {/* {firearms?.length > 0 && (
                    <Grid item sm={6} xs={12}>
                        <PageHeader title="Payment" />
                        <Payment />
                    </Grid>
                )} */}

                <Grid item sm={6} xs={12}>
                    <FirearmInsurance />
                </Grid>
            </Grid>
        </div>
    )
}

const mapStateToProps = (store: any) => {
    return {
        firearms: store?.client?.firearms?.firearmData,
        metadataFirearms: store?.client?.firearms?.metadataFirearms,
        accessories: store?.client?.accessories?.accessoriesData,
        metadataAccessories: store?.client?.accessories?.metadataAccessories,
        parts: store?.client?.parts?.partData,
        metadataParts: store?.client?.parts?.metadataParts,
    }
}

const mapDispatchToProps = (dispatch: Redux.Dispatch) => {
    return {
        getFirearms: (params: ICommonQuery) =>
            dispatch(ClientFirearmActions.getItems('FIREARM', params) as any),
        getAccessories: (params: ICommonQuery) =>
            dispatch(ClientFirearmActions.getItems('ACCESSORY', params) as any),
        getParts: (params: ICommonQuery) =>
            dispatch(ClientFirearmActions.getItems('PART', params) as any),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Firearm)
